import React, { useState, useEffect, useCallback } from "react";
import { ids, styles } from "./AllTripCss";
import AppBar from "../Layout/AppBar";
import {
  View,
  ScrollView,
  Dimensions,
  RefreshControl,
  Text,
} from "react-native";
import TripCard from "../TripDashboard/TripCard/TripCard";
import { GetFilterTripAPI } from "../../service/api/trip/api";
import NotFoundTripCard from "../TripDashboard/TripCard/NotFoundTripCard";
import SearchTrip from "../TripDashboard/SearchTrip/SearchTrip";
import { primaryColor, subTextColor } from "../../constant/constantCss";
import { useRoute } from "@react-navigation/native";
import PublicAppBar from "../Layout/PublicAppBar";
import { showToast } from "../../constant/toastMessage";
import PlaneLoader from "../../components/Loader";
import ContactUs from "../LnadingPage/components/ContactUs";
import FeaturedTrips from "./FeaturedTrips";
import TripFilterModal from "../TripDashboard/TripFilterModal/TripFilterModal";
import { Button } from "react-native-paper";

const AllTrip = () => {
  const [loader, setloader] = useState(false);
  const [isVisibleFilterModal, setIsVisibleFilterModal] = useState(false);
  const [refreshing, setRefreshing] = useState(false);
  const [tripDetails, settripDetails] = useState([]);
  const screenHeight = Dimensions.get("window").height;
  const route = useRoute();
  const isPublicURL = route.params?.isPublic;

  const initialCallingAPI = () => {
    setloader(true);
    GetFilterTripAPI("all")
      .then((res) => {
        settripDetails(res.data?.data);
        setloader(false);
      })
      .catch((err) => {
        showToast("error", err?.response?.data?.detail);
        setloader(false);
      });
  };
  const onRefresh = useCallback(() => {
    setRefreshing(true);
    setTimeout(() => {
      initialCallingAPI();
      setRefreshing(false);
    }, 1000);
  }, []);

  // Call Upcoming Trip API
  useEffect(() => {
    initialCallingAPI();
  }, []);

  return (
    <View style={[styles.container, { minHeight: screenHeight }]}>
      {!isPublicURL ? <AppBar /> : <PublicAppBar />}
      <ScrollView
        refreshControl={
          <RefreshControl
            refreshing={refreshing}
            onRefresh={onRefresh}
            tintColor={primaryColor}
            colors={[primaryColor]}
          />
        }
      >
        <View style={styles.subContainer} dataSet={{ media: ids.subContainer }}>
          <FeaturedTrips />
          <Text style={styles.headingText}>
            All Trip ({tripDetails?.length})
          </Text>
          <View
            style={{
              display: "flex",
              flexDirection: "row",
              alignContent: "center",
              alignItems: "center",
              gap: 20,
              flex: 1,
            }}
          >
            <SearchTrip setTripDetails={settripDetails} filterValue={"all"} />
            <Button
              mode="outlined"
              icon={"filter"}
              textColor={subTextColor}
              style={{
                borderRadius: 10,
                marginBottom: 10,
                paddingVertical: Dimensions.get("screen").width >= 480 ? 0 : 8,
              }}
              onPress={() => {
                setIsVisibleFilterModal(true);
              }}
            >
              {Dimensions.get("screen").width >= 480 && "Filter"}
            </Button>
          </View>

          <View
            style={[
              styles.cardView,
              tripDetails?.length < 4 && { justifyContent: "left" },
            ]}
            dataSet={{ media: ids.cardView }}
          >
            {loader ? (
              <PlaneLoader />
            ) : tripDetails?.length > 0 ? (
              tripDetails?.map((item, index) => (
                <TripCard
                  key={index}
                  id={item.id}
                  title={item.title}
                  address={item.address}
                  is_public={item.is_public}
                  amount={item.amount}
                  image={item.image_url}
                  departure_date={item.departure_date}
                  no_of_days={item.no_of_days}
                />
              ))
            ) : (
              <NotFoundTripCard />
            )}
          </View>
        </View>
        <ContactUs />
        {isVisibleFilterModal && (
          <TripFilterModal
            visible={isVisibleFilterModal}
            setTripDetails={settripDetails}
            filterValue={"all"}
            handleClose={() => setIsVisibleFilterModal(false)}
          />
        )}
      </ScrollView>
    </View>
  );
};

export default AllTrip;
